// extracted by mini-css-extract-plugin
export var actions = "_tu-4";
export var item = "_tu-1";
export var price = "_tu-3";
export var quantity = "_tu-2";
export var table = "_tu-0";